export class SnapshotRecipe {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "baseSnapshotId",
            "baseName": "baseSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "proposal",
            "baseName": "proposal",
            "type": "SnapshotRecipeProposal",
            "format": ""
        },
        {
            "name": "rules",
            "baseName": "rules",
            "type": "Array<SnapshotRecipeRule>",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SnapshotRecipeStatus",
            "format": ""
        },
        {
            "name": "revision",
            "baseName": "revision",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "SnapshotRecipeSummary",
            "format": ""
        },
        {
            "name": "ruleErrors",
            "baseName": "ruleErrors",
            "type": "Array<SnapshotRecipeRuleError>",
            "format": ""
        },
        {
            "name": "failureReason",
            "baseName": "failureReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "validity",
            "baseName": "validity",
            "type": "SnapshotRecipeValidity",
            "format": ""
        },
        {
            "name": "createdByUserId",
            "baseName": "createdByUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdByApiCredentials",
            "baseName": "createdByApiCredentials",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "updatedByUserId",
            "baseName": "updatedByUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedByApiCredentials",
            "baseName": "updatedByApiCredentials",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipe.attributeTypeMap;
    }
    constructor() {
    }
}
